import { useRef } from "react";

import { Editor } from "@hugerte/hugerte-react";
import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import BaseLabel from "components/BaseLabel";

import { EditorContainer } from "./styles";

interface EmailTemplateProps {
  setEditedValue: (value: string) => void;
  editedValue: string;
  fieldError: boolean;
}

const EmailTemplate = ({
  setEditedValue,
  editedValue,
  fieldError,
}: EmailTemplateProps) => {
  const { t } = useTranslation();
  const editorRef = useRef<any>(null);

  const editorConfig = {
    height: 400,
    menubar: false,
    branding: false,
    resize: false,
    plugins: [
      "advlist",
      "autolink",
      "lists",
      "link",
      "charmap",
      "code",
      "insertdatetime",
      "table",
      "wordcount",
    ],
    toolbar:
      "undo redo | blocks | " +
      "bold italic forecolor backcolor | alignleft aligncenter " +
      "alignright alignjustify | bullist numlist outdent indent | " +
      "link table | code | removeformat",
    content_style:
      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
    placeholder: t("systemConfiguration.emailTemplate.placeholder"),
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <BaseLabel
          fontSize="18px"
          fontWeight="700"
          marginBottom="8px"
          marginTop="0px"
          marginLeft="0px"
          marginRight="0px"
        >
          {t("systemConfiguration.emailTemplate.title")}
        </BaseLabel>
      </Grid>
      <Grid item xs={12}>
        <EditorContainer error={fieldError}>
          <Editor
            ref={editorRef}
            inline={false}
            onEditorChange={(content) => setEditedValue(content)}
            value={editedValue}
            onInit={(editor) => (editorRef.current = editor)}
            init={editorConfig}
          />
        </EditorContainer>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            color: "#666",
            marginTop: "8px",
            "& code": {
              backgroundColor: "#f4f4f4",
              padding: "2px 6px",
              borderRadius: "3px",
              fontFamily: "monospace",
              fontSize: "13px",
            },
          }}
        >
          <strong>
            {t("systemConfiguration.emailTemplate.availableVariables")}
          </strong>
          <br />• <code>{"{content}"}</code> -{" "}
          {t("systemConfiguration.emailTemplate.varContent")}
        </Box>
      </Grid>
    </Grid>
  );
};

export default EmailTemplate;
